/**
 * 支付流程：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=472807223
 *
 * 提单异常处理逻辑：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=472807223
 * 1. 提单异常
 * 2. 提单异常响应逻辑
 *
 * 支付异常处理逻辑：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=182813871
 * 1. 支付异常
 * 2. 支付异常响应逻辑
 */
import i18n from '@/i18n/locale';

export const PAY_SDK_MSG_MAP = {
  [-1]: i18n.t('sailing.c-api-intl.内部系统错误'),
  [82019]: i18n.t('sailing.c-api-intl.内部系统错误'),
  [900000]: i18n.t('sailing.c-api-intl.交易失败，请联系发卡行核实后重试'),
  [900001]: i18n.t(
    'sailing.c-api-intl.交易失败，请核对信息后重试，或更换其他支付方式'
  ),
  [900002]: i18n.t(
    'sailing.c-api-intl.无法识别卡信息，请核对信息后重试，或更换其他支付方式'
  ),
  [900003]: i18n.t('sailing.c-api-intl.交易失败，请联系发卡行核实后重试'),
  [900004]: i18n.t('sailing.c-api-intl.交易失败，请联系发卡行核实后重试'),
  [900005]: i18n.t('sailing.c-api-intl.交易失败，请联系发卡行核实后重试'),
  [900006]: i18n.t('sailing.c-api-intl.交易失败，请联系发卡行核实后重试'),
  [900007]: i18n.t('sailing.c-api-intl.卡冻结，请更换其他支付方式'),
  [900008]: i18n.t('sailing.c-api-intl.发卡行异常，请更换其他支付方式'),
  [900009]: i18n.t('sailing.c-api-intl.卡已失效，请更换其他支付方式'),
  [900010]: i18n.t('sailing.c-api-intl.安全码无效，请核对信息后重试'),
  [900011]: i18n.t('FoodC_busy_System_busy_QOvT'),
  [900012]: i18n.t('sailing.c-api-intl.交易失败，请稍后重试'),
  [900013]: i18n.t('sailing.c-api-intl.金额无效，请核对交易金额后重试'),
  [900014]: i18n.t('sailing.c-api-intl.余额不足，请更换其他支付方式'),
};

function collectionToMap(collection) {
  let map = {};
  Object.keys(collection).forEach((key) => {
    let list = collection[key];
    list.forEach((value) => {
      map[value] = Number(key);
    });
  });
  return map;
}
/**
 * 提单异常响应逻辑
 */
export const SUBMIT_ORDER_ERROR_RESPONSE_TYPE = {
  // 只弹窗
  PUP: 1,
  // 弹窗，”确认“后刷新提单页
  PUP_REFRESH: 2,
  // 弹窗跳支付列表
  PUP_PAY: 3,
  // 登录异常	跳转登陆
  LOGIN_ERR: 4,
};

/**
 * 提单异常  http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=928819233
 */
export const SUBMIT_ORDER_ERROR_RESPONSE_COLLECTION = {
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_PAY]: [
    41614, 41616, 41618, 41619, 41054,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP]: [
    41600, 41601, 41602, 41603, 41604, 41605, 41606, 41607, 41608, 41609, 41610,
    41611, 41612, 41615, 41617, 41055, 41067, 41069,
  ],
  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.PUP_REFRESH]: [
    100003, 100004, 100007, 100008, 40012, 40113, 40115, 41000, 41030, 41033,
    41034, 41010, 41011, 41012, 41013, 41014, 41015, 41020, 41021, 41022, 41025,
    41026, 41030, 41036, 41039, 41050, 41080, 41090, 41092, 41043, 41047, 44040,
    44021, 44022, 44100, 45000, 45050, 45051, 45300,
  ],

  [SUBMIT_ORDER_ERROR_RESPONSE_TYPE.LOGIN_ERR]: [
    50000, 50001, 50002, 50003, 50004, 50005,
  ],
};

export const SUBMIT_ORDER_RESPONSE_ERROR_MAP = collectionToMap(
  SUBMIT_ORDER_ERROR_RESPONSE_COLLECTION
);

/**
 * 支付异常响应逻辑
 */
export const PAY_ERROR_RESPONSE_TYPE = {
  // 内部错误，重试
  RETRY: 1,
  // 外部错误，弹窗提示后刷新提单页
  PUP_REFRESH: 2,
};

// http://pay.intra.xiaojukeji.com/#techwiki/view/170
// 1 未支付；2 免密支付中；3 已支付；4 免密支付失败；5 线下支付；6 风控关单；7 已关单
export const PAY_STATUS = {
  NOT_PAY: 1,
  IN_PAY: 2,
  PAID: 3,
  ERR: 4,
  OFFLINE: 5,
  RISK: 6,
  CLOSE: 7,
};

export const PAY_REQUEST_STATUS = {
  SUCCESS: 0,
  PARAMS_MISS: '81002',
};

export const PAY_CHANNEL_TYPE = {
  // Paypay 免密支付
  CHANNEL_PAYPAY: 182,
  // 99pay
  CHANNEL_WALLET: 190,
  // 现金支付
  CHANNEL_CASH: 153,
  // 在线支付
  CHANNEL_CREDIT_CARD: 150,
  // POS 机支付
  CHANNEL_POS: 154,
};

export const PAYMENT_QUERY_CALLBACK = {
  // 网络请求
  REQUEST_LEVEL: {
    isNetworkError(res) {
      // 网络异常
      return res.errno === -1;
    },
    isParamsMissing(res) {
      // 缺少 transId
      return res.errno === PAY_REQUEST_STATUS.PARAMS_MISS;
    },
  },
  // 支付业务
  BUSINESS_LEVEL: {
    // 请求成功，request直接返回 res.data
    isParamsError(data) {
      // transId 取值异常
      return (
        data.pay_status === PAY_STATUS.NOT_PAY &&
        data.pay_status_detail === void 0
      );
    },
    isCheck(data) {
      const status = [
        PAY_STATUS.PAID,
        PAY_STATUS.ERR,
        PAY_STATUS.OFFLINE,
        PAY_STATUS.RISK,
        PAY_STATUS.CLOSE,
      ];
      return status.includes(data.pay_status);
    },
    isSuccess(data) {
      return data.pay_status === PAY_STATUS.PAID;
    },
    isTimeout(data) {
      return data.pay_status === PAY_STATUS.IN_PAY;
    },
    isFail(data) {
      let isSuccess = data.pay_status === PAY_STATUS.PAID;
      let isTimeout = data.pay_status === PAY_STATUS.IN_PAY;
      return !isSuccess && !isTimeout;
    },
  },
};

/** @desc 契约单支付状态，100支付中，200支付成功，900异常 */
export const PAY_CONTRACT_STATUS = { in_pay: 100, paid: 200, not_pay: 900 };
export const PAY_FUNC = {
  isResult(data) {
    if (PAY_FUNC.isSuccess(data) || PAY_FUNC.isFail(data)) {
      return true;
    } else {
      return false;
    }
  },
  isSuccess(data) {
    return data?.contractOrder?.status === PAY_CONTRACT_STATUS.paid;
  },
  isFail(data) {
    return data?.contractOrder?.status === PAY_CONTRACT_STATUS.not_pay;
  },
  selectSuccess(data) {
    let transactionID = data?.contractOrder?.transactionID || false;
    let isErr = data?.contractOrder?.status === PAY_CONTRACT_STATUS.not_pay;
    let isOk = data?.contractOrder?.status === PAY_CONTRACT_STATUS.paid;
    // 有transactionID || 200成功 || 900异常
    return transactionID || isErr || isOk;
  },
  haveTransId(data) {
    let transactionID = data?.contractOrder?.transactionID || false;

    return transactionID;
  },
};
